import { type CSSProperties, useState } from 'react';

import { inputStyle, radioStyle } from './Survey.css';
import type { Question, QuestionOption } from './Survey.types';
interface Props {
  question: Question;
  questionOption: QuestionOption;
  checkedBoxes: number;
  setCheckedBoxes: (value: number) => void;
}

const MultipleChoiceInput = ({ question, questionOption, checkedBoxes, setCheckedBoxes }: Props) => {
  let isRequired = question.required;
  if (isRequired && question.multi_select && checkedBoxes > 0) {
    isRequired = false;
  }

  const handleCheck = (e: any) => {
    if (e.target.checked) {
      setCheckedBoxes(checkedBoxes + 1);
    } else {
      setCheckedBoxes(checkedBoxes - 1);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
        flexDirection: 'var(--radio-option-flex-direction, "row")' as CSSProperties['flexDirection'],
        justifyContent: 'var(--radio-option-justify-content)',
      }}
    >
      <input
        id={questionOption.id}
        name={question.id}
        value={questionOption.value}
        className={radioStyle}
        type={question.multi_select ? 'checkbox' : 'radio'}
        required={isRequired}
        defaultChecked={false}
        onChange={(e) => {
          handleCheck(e);
        }}
      />
      <label
        htmlFor={questionOption.id}
        className={inputStyle}
        style={{
          backgroundColor: 'var(--answer-background-color)',
          color: 'var(--answer-text-color)',
          fontFamily: 'var(--answer-text-font-family)',
        }}
      >
        {questionOption.value}
      </label>
    </div>
  );
};

interface MultipleChoiceProps {
  question: Question;
}

const MultipleChoice = ({ question }: MultipleChoiceProps) => {
  const [checkedBoxes, setCheckedBoxes] = useState(0);

  return (
    <fieldset>
      {question.form_question_options.map((questionOption: QuestionOption) => {
        return (
          <MultipleChoiceInput
            key={questionOption.id}
            question={question}
            questionOption={questionOption}
            checkedBoxes={checkedBoxes}
            setCheckedBoxes={setCheckedBoxes}
          />
        );
      })}
    </fieldset>
  );
};

export default MultipleChoice;
